import { useEffect, useState } from "react";
// import { motion } from "framer-motion";
import styled, { keyframes } from "styled-components";
import { useIntersecting } from "../../hooks/useIntersecting";
import { colorV2, cssTemplate, media } from "../../constants/styles";
import { ScreenType } from "../sections/shared/types";
// import SKRenterCar from "../../../public/image/home/sk-rentercar.svg";

interface Props {
  screenType: ScreenType;
}

const partners = [
  <img src="/image/home/sk-rentercar.svg" alt="SK Rent a Car" />,
  <img src="/image/home/sk-networks.svg" alt="SK Networks" />,
  <img src="/image/home/sk-gas.svg" alt="SK Gas" />,
  <img src="/image/home/lg.svg" alt="LG" />,
  <img src="/image/home/cartini.svg" alt="Cartini" />,
  <img src="/image/home/mintit.svg" alt="Mintit" />,
  <img src="/image/home/tirepick.svg" alt="Tirepick" />,
  <img src="/image/home/everon.svg" alt="Everon" />,
  <img src="/image/home/sm.svg" alt="SM" />,
  <img src="/image/home/ls-mtron.svg" alt="LS Mtron" />,
  <img src="/image/home/ecoya.svg" alt="Ecoya" />,
];

const PartnersCarousel: React.FC<Props> = () => {
  const { ref, isIntersecting } = useIntersecting();
  const [interacted, setInteracted] = useState<boolean>(false);

  useEffect(() => {
    if (isIntersecting) setInteracted(true);
  }, [isIntersecting]);

  return (
    <Container ref={ref} theme={{ isIntersecting: interacted }}>
      <InnerScroller>
        {[...partners, ...partners].map((icon, index) => (
          <PartnerItem key={index}>{icon}</PartnerItem>
        ))}
      </InnerScroller>
    </Container>
  );
};

export default PartnersCarousel;

const Container = styled.div`
  ${(props) => cssTemplate.fadeInOut(props)}
  overflow: hidden;
  width: 100vw;
  background: ${colorV2.PRIMARY_01};
`;

const PartnerItem = styled.figure`
  position: relative;
  width: 400px;
  height: 146px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 200px;
    height: 100px;
    object-fit: contain;
  }

  ${media.MOBILE} {
    width: 320px;
    height: 146px;

    img {
      width: 150px;
      height: 75px;
      object-fit: contain;
    }
  }
`;

const scrollKeyframe = keyframes`
to {
  transform: translate(calc(-50%));
}
`;

const InnerScroller = styled.div`
  background: ${colorV2.GRAY_01};
  width: max-content;
  display: flex;
  gap: 32px;
  animation: ${scrollKeyframe} 50s linear infinite;
`;
